export default __webpack_public_path__ + "45ba61ecf4ce27dd2c292f79e07c5980.png";